import BatchActions, { batchActionTypes } from '@Actions/batchActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, all, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import BatchServices from '@Services/batchServices';

/**
 * @param action
 */
function* _getBatches(action) {
  try {
    yield put(BatchActions.getBatchesLoading(true));
    const {
      tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch, endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock,
    } = action;
    const batches = yield BatchServices.getBatches(tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch, endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock);
    yield put(BatchActions.getBatchesSuccess(batches));
    yield put(BatchActions.getBatchesLoading(false));
  } catch (error) {
    yield put(BatchActions.getBatchesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(batchActionTypes.GET_BATCHES.ERROR, error));
  }
}

/**
 *
 */
function* getBatches() {
  yield takeEvery(batchActionTypes.GET_BATCHES.REQUEST, _getBatches);
}

function* _createBatch(action) {
  try {
    yield put(BatchActions.createBatchLoading(true));
    const { payload } = action;
    const batches = yield BatchServices.createBatch(payload);
    if (!batches.success) {
      notification.open({
        type: 'error',
        message: batches?.message,
        duration: 4,
        placement: 'top',
      });
    } else if (action.callback) {
      action.callback();
    }
    yield put(BatchActions.createBatchLoading(false));
  } catch (error) {
    yield put(BatchActions.createBatchLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(batchActionTypes.CREATE_BATCH.ERROR, error));
  }
}

function* createBatch() {
  yield takeEvery(batchActionTypes.CREATE_BATCH.REQUEST, _createBatch);
}

function* _getReservations(action) {
  try {
    yield put(BatchActions.getReservationsLoading(true));
    const { payload } = action;
    const batches = yield BatchServices.getReservations(payload);
    yield put(BatchActions.getReservationsSuccess(batches?.data));
    if (!batches.success) {
      notification.open({
        type: 'error',
        message: batches?.message,
        duration: 4,
        placement: 'top',
      });
    } else if (action.callback) {
      action.callback();
    }
    yield put(BatchActions.getReservationsLoading(false));
  } catch (error) {
    yield put(BatchActions.getReservationsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getReservations() {
  yield takeLatest(batchActionTypes.GET_RESERVATIONS.REQUEST, _getReservations);
}

/**
 *
 */
export default function* batchSaga() {
  yield all([
    getBatches(),
    createBatch(),
    getReservations(),
  ]);
}
